<form [formGroup]="_changePassForm">
	<div class="form-label-group">
		<input type="text" formControlName="Email" id="Email" class="form-control form-control-lg" placeholder="Email" [ngClass]="{ 'is-invalid': clicked && _changePassForm.controls.Email.invalid }" required autofocus>
		<label>Email</label>
		<div *ngIf="clicked && _changePassForm.controls.Email.invalid" class="invalid-feedback">
		  <div *ngIf="_changePassForm.controls.Password.errors.required">Required</div>
		</div>
	  </div>
	<div class="form-label-group">
		<input type="password" formControlName="OldPassword" id="OldPassword" class="form-control form-control-lg" placeholder="OldPassword" [ngClass]="{ 'is-invalid': clicked && _changePassForm.controls.OldPassword.invalid }" required autofocus>
		<label>Old Password</label>
		<div *ngIf="clicked && _changePassForm.controls.OldPassword.invalid" class="invalid-feedback">
		  <div *ngIf="_changePassForm.controls.Password.errors.required">Required</div>
		</div>
	  </div>
	<div class="form-label-group">
	  <input type="password" formControlName="NewPassword" id="NewPassword" class="form-control form-control-lg" placeholder="NewPassword" [ngClass]="{ 'is-invalid': clicked && _changePassForm.controls.NewPassword.invalid }" required autofocus>
	  <label>New Password</label>
	  <div *ngIf="clicked && _changePassForm.controls.NewPassword.invalid" class="invalid-feedback">
		<div *ngIf="_changePassForm.controls.Password.errors.required">Required</div>
	  </div>
	</div>
	<div class="form-label-group">
	  <input type="password" formControlName="ConfirmPassword" id="ConfirmPassword" class="form-control form-control-lg" placeholder="Confirm Password" [ngClass]="{ 'is-invalid': clicked && _changePassForm.controls.ConfirmPassword.invalid }" (keyup.enter)="changePassword()" required>
	  <label>Confirm Password</label>
	  <div *ngIf="clicked && _changePassForm.controls.ConfirmPassword.invalid" class="invalid-feedback">
		<div *ngIf="_changePassForm.controls.ConfirmPassword.errors.required">Required</div>
	  </div>
	</div>
	<div class="form-group">
	  <button type="submit" class="btn btn-main" [disabled]="isAuthenticating" type="button" (click)="changePassword()">
		{{ isAuthenticating ? 'Changing password...' : 'Change Password'  }} &nbsp;<i *ngIf="isAuthenticating" class="fas fa-spinner fa-spin"></i>
	  </button>
	</div>
</form>